<script setup>
import { router, useForm } from '@inertiajs/vue3';
import JetButton from '@/Jetstream/Button.vue';
import JetFormSection from '@/Jetstream/SimpleFormSection.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetLabel from '@/Jetstream/Label.vue';
import MultiSelect from '@vueform/multiselect';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';
// Get locale as set in cookie
let { locale } = useI18n({ useScope: 'global' });

const props = defineProps({
    availableTeams: Array,
    teamsExist: Boolean,
    DisplayProgramTypeOptions: Boolean,
    teamInvites: Array
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

let team_custom_name = programme.team_custom_name;
if (team_custom_name) {
    if(team_custom_name.constructor.name != 'Object') {
        team_custom_name = JSON.parse(team_custom_name);
    }
}

let default_team_name;

if (locale.value == 'cy') {
    default_team_name = 'tîm';

} else  {
    default_team_name = 'team';
}

let team_name = default_team_name;

if (team_custom_name) {
    team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
}

    const createForm = useForm({
    name: '',
    programmeType: 'Team'

});

const joinForm = useForm({
    team_id: 0,
    programmeType: 'Team'
});

const setProgrammeType = (type) => {
    createForm.programmeType = type;
    joinForm.programmeType = type;
};

const createTeam = () => {
    createForm.post(route(urlNamePrefix+'teams.store'), {
        errorBag: 'createTeam',
        preserveScroll: true,
    });
};

const joinTeam = () => {
    joinForm.post(route(urlNamePrefix+'teams.join'), {
        errorBag: 'joinTeam',
        preserveScroll: true,
    });
};

const acceptInvite = (index) => {
    router.post(route(urlNamePrefix+'team-invitations.accept', {invitation: router.page.props.auth.user.team_invites[index] }));
}

const rejectInvite = (index) => {
    router.post(route(urlNamePrefix+'team-invitations.reject', {invitation: router.page.props.auth.user.team_invites[index] }));
}

</script>

<template>

    <div v-if="props.DisplayProgramTypeOptions">
        <h1 class="pt-5 pl-10 dashboard-title">{{ $t('teams.join.progammes.title', { team_name: team_name }) }}</h1>
        <div class="p-10 pt-0 lg:pr-0">
            <div>
                <div class="p-6 bg-white border-b border-gray-200 rounded-2xl">
                    <div class="mt-0 text-gray-500">
                        <div class="mt-20 mb-20">
                            <div class="flex flex-col md:flex-row md:justify-center md:items-center">
                                <div class="form-item">
                                    <input type="radio" id="joinTeam1" name="join-team" value="" class="" checked="checked" v-on:click="setProgrammeType('Team')" />
                                    <label for="joinTeam1" class="ml-5 mr-5 text-base font-bold sm:mr-10 sm:text-lg">{{ programme.name }} {{ $t('teams.join.progammes.teams') }}</label>
                                </div>
                                <div class="form-item">
                                    <input type="radio" id="joinTeam2" name="join-team" value="" class="" v-on:click="setProgrammeType('Individual')" />
                                    <label for="joinTeam2" class="ml-5 mr-5 text-base font-bold sm:text-lg">{{ programme.name }}  {{ $t('teams.join.progammes.individuals') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <h2 v-if="props.teamsExist === false" class="pt-5 pl-10 dashboard-title">{{ $t('teams.create.title', { team_name: team_name }) }}</h2>
    <h2 v-if="props.teamsExist === true" class="pt-5 pl-10 dashboard-title">{{ $t('teams.join.teams.title', { team_name: team_name }) }}</h2>
    <div class="p-10 pt-0 lg:pr-0">
        <div>
            <div v-if="$page.props.auth.user.team_invites && $page.props.auth.user.team_invites.length > 0" class="p-6 mb-2 bg-white border-b border-gray-200 rounded-2xl">
                <div class="team-invites">
                    <h2>{{$t(team_name)}} Invitations</h2>
                    You have pending {{$t(team_name)}} invitations.
                </div>
                <table class="w-full mt-3 table-fixed">
                    <tr v-for="(invite, index) in $page.props.auth.user.team_invites">
                        <td>
                            <span class="font-bold">Team name:</span> {{ props.availableTeams[invite.team_id] }}
                        </td>
                        <td class="text-center">
                            <JetButton v-on:click="acceptInvite(index)" class="w-full text-center" style="display: block;">
                                Accept Invite
                            </JetButton>
                        </td>
                        <td class="text-center">
                            <JetButton v-on:click="rejectInvite(index)" class="w-full text-center" style="display: block;">
                                Reject Invite
                            </JetButton>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 rounded-2xl">
                <div v-if="props.teamsExist" class="mt-0 text-gray-500">
                    <div class="mt-10 mb-10 form-item-container">
                        <JetFormSection @submitted="joinTeam">
                            <template #form>
                                <JetLabel for="selectTeam" class="flex flex-col justify-center sm:flex-row">
                                    Already know the {{$t(team_name)}} you want to join? Search for them below.
                                </JetLabel>
                                <div class="flex flex-col pt-5 form-item md:flex-row md:justify-center">
                                    <MultiSelect
                                        id="selectTeam"
                                        v-model="joinForm.team_id"
                                        :options="props.availableTeams"
                                        :searchable="true"
                                        placeholder="Search"
                                        class="w-full border-gray-300 rounded-md md:mr-5 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                        >
                                    </MultiSelect>

                                    <input type="hidden" id="programmeType" value="team" />

                                    <JetInputError :message="joinForm.errors.name" class="mt-2" />

                                    <JetButton :class="{ 'whitespace-nowrap w-full mt-5 md:mt-0 sm:inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-base text-white tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition opacity-25': joinForm.processing } " :disabled="joinForm.processing">
                                        {{ $t('teams.join.teams.join', { team_name: team_name }) }}
                                    </JetButton>
                                </div>
                            </template>
                        </JetFormSection>
                    </div>
                </div>

                <div class="mt-0 text-gray-500">
                    <div class="mt-10 mb-10 form-item-container">
                        <JetFormSection @submitted="createTeam">
                            <template #form>
                                <JetLabel for="name" :value="$t('teams.join.teams.info', { team_name: team_name })" class="flex flex-col justify-center sm:flex-row" />

                                <div class="flex flex-col pt-5 pb-0 form-item md:flex-row md:justify-left">
                                    <JetInputError :message="createForm.errors.name" class="mt-2" />
                                </div>

                                <div class="flex flex-col pt-5 form-item md:flex-row md:justify-center">

                                    <JetInput
                                        id="name"
                                        v-model="createForm.name"
                                        type="text"
                                        class="w-full border-gray-300 rounded-md md:mr-5 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                        autofocus
                                        :placeholder="$t('teams.create.name', { team_name: team_name })"
                                    />

                                   <input type="hidden" id="programmeType" value="team" />

                                    <JetButton :class="{ 'whitespace-nowrap w-full mt-5 md:mt-0 sm:inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-base text-white tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition opacity-25': createForm.processing } " :disabled="createForm.processing">
                                        {{ $t('teams.create.create') }}
                                    </JetButton>

                                </div>
                            </template>
                        </JetFormSection>
                    </div>
                </div>
         </div>
        </div>
    </div>
    <!-- <div class="flex flex-row justify-center p-10 pt-0">
        <button :type="submit" class="items-center w-auto px-4 py-2 pl-10 pr-10 mt-5 text-lg font-semibold text-white transition bg-gray-800 border border-transparent rounded-md whitespace-nowrap md:mt-0 sm:inline-flex hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25">
            Let's go!
        </button>
    </div> -->
</template>
